import React from 'react'
import { Modal } from 'reactstrap'
import Success from '../../../../components/SuccessAnimation'
import { useNavigate } from 'react-router-dom'

const TransactionSuccesful = ({
    isOpen,
    toggle,
    setSection,
    bank_name,
    account_number }) => {
    const navigate = useNavigate()
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className='modal-dialog-centered '
            contentClassName="upload-success__modal_content-wrapper  "
        >
            <div className='analytics-card transaction__modal position-relative'>
                <form className=''>
                    <div className='animation-wrapper'>
                        <Success />
                    </div>
                    <p className='congrats-text'>Congratulations! </p>
                    <p className='congrats-sub-text'>You have successfully added <span className='fw-bold'>{account_number}</span>, <span className='fw-bold'>{bank_name}</span> Bank to your profile</p>
                    <div className='sign-in-btn'>
                        <button className='btn auth-btn w-100 ' onClick={(e) => {
                            e.preventDefault()
                            setSection('bank_list')
                        }}>
                            Done
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default TransactionSuccesful